import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";

const SECTIONS = [
  {
    t: "1. Who we are",
    b: "Aurevia Travella is the data controller for personal data collected through this website. Registered office: 102 Rookery Court, 80 Ruckholt Road, Mainyard Studios, Office C05, Suite G1276, London, E10 5FA, United Kingdom. You can reach us at support@aureviatravella.com or +90 543 518 96 50.",
  },
  {
    t: "2. What we collect",
    b: "When you submit the concierge inquiry form we collect your name, email address, optional destination preference, your message and your language preference. We also process standard technical data (browser type, approximate location from IP) required to serve the site securely.",
  },
  {
    t: "3. Lawful basis (UK GDPR)",
    b: "We process inquiry data on the basis of your consent and our legitimate interest in responding to your travel request (UK GDPR Art. 6(1)(a) and 6(1)(f)). Technical data is processed under our legitimate interest in operating a secure, performant service.",
  },
  {
    t: "4. How we use your data",
    b: "Your inquiry is used solely to assign a travel designer who will contact you about your trip. We do not sell, rent or trade personal data, and we do not use it for automated decision-making or profiling.",
  },
  {
    t: "5. Storage, retention & transfers",
    b: "Data is stored on encrypted infrastructure. Inquiries are kept for up to 24 months, then deleted. Where data is transferred outside the UK, we rely on adequacy regulations or standard contractual clauses in line with UK GDPR Chapter V.",
  },
  {
    t: "6. Your rights",
    b: "Under UK GDPR you have the right to access, rectify, erase, restrict or object to the processing of your personal data, the right to data portability, and the right to withdraw consent at any time. To exercise any right, email support@aureviatravella.com — we respond within one month.",
  },
  {
    t: "7. Complaints",
    b: "If you are unhappy with how we handle your data, you can complain to the UK supervisory authority: Information Commissioner's Office (ICO), Wycliffe House, Water Lane, Wilmslow, Cheshire, SK9 5AF — ico.org.uk.",
  },
  {
    t: "8. Cookies",
    b: "This site uses only essential technical storage (your language preference). No advertising or cross-site tracking cookies are used.",
  },
];

export default function PrivacyPage() {
  return (
    <main data-testid="privacy-page">
      <Navbar />
      <section className="relative py-40 lg:py-48">
        <div className="mx-auto max-w-3xl px-6">
          <Reveal>
            <p className="eyebrow mb-6">Legal</p>
            <h1 className="font-serif text-4xl font-light leading-tight text-white sm:text-5xl" data-testid="privacy-title">
              Privacy Policy & UK GDPR
            </h1>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-white/40">
              Last updated: 28 August 2026
            </p>
          </Reveal>
          <div className="mt-14 space-y-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={i} delay={Math.min(i * 0.05, 0.3)}>
                <div className="border-t border-white/10 pt-6">
                  <h2 className="font-serif text-xl font-light text-[#e8cf7a]">{s.t}</h2>
                  <p className="mt-3 text-sm font-light leading-relaxed text-white/65">{s.b}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
